export default {"id":"c4f8d21b","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}